import { useState } from "react";

const telefono = () => typeof window !== "undefined" && window.matchMedia("(max-width: 760px)").matches;

// Sottosezione di «Altro»: aperta sul computer, richiudibile sul telefono (come nei riferimenti).
export default function BloccoAltro({ titolo, nota, children, testid, azioni }) {
  const [open, setOpen] = useState(!telefono());
  return (
    <div className="sub" data-testid={testid}>
      <div className="subt">
        <button onClick={() => setOpen(!open)} data-testid={`${testid}-toggle`}
          className="flex-grow flex items-center justify-between gap-2.5 text-left min-w-0">
          <span className="truncate">{titolo}</span>
          <span className="md:hidden text-[#5A5A5A] font-normal">{open ? "⌃" : "›"}</span>
        </button>
        {nota && <span className="hidden md:inline text-[12px] font-normal normal-case tracking-normal text-[#5A5A5A]">{nota}</span>}
        {azioni}
      </div>
      {open && children}
    </div>
  );
}
